var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-index"},[_c('featureTicker',{attrs:{"price24":_vm.price24},on:{"showMarket":_vm.onShowMarket}}),_c('featureHandle',{attrs:{"showMarket":_vm.showMarket,"price24":_vm.price24},on:{"update:showMarket":function($event){_vm.showMarket=$event},"update:show-market":function($event){_vm.showMarket=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }